import {ProfileComparisonSectionContent} from './ProfileComparisonSectionContent';

export interface Props {
  companyId: string;
  departmentId: string;
  departmentName: string;
}

export const ProfileComparisonSection = ({companyId, departmentId, departmentName}: Props) => (
  <ProfileComparisonSectionContent
    key={departmentId}
    companyId={companyId}
    departmentId={departmentId}
    departmentName={departmentName}
  />
);
